function getAssetUrl(filename) {
  return assetUrl + filename;
}

const debounce =
  typeof globalThis.debounce === 'function'
    ? globalThis.debounce
    : function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 * Initialize add-to-cart button event listeners
 * This function should be called whenever product cards are rendered or re-rendered
 */
/**
 * Initialize add-to-cart button event listeners
 * This function should be called whenever product cards are rendered or re-rendered
 */
function initializeAddToCartButtons() {
  document.querySelectorAll('.qlf-add-to-cart:not(.bound)').forEach((element) => {
    element.classList.add('bound');
    const button = element.querySelector('button');

    if (!button) {
      console.warn('Add-to-cart button not found in element:', element);
      return;
    }

    const oldHandler = button._clickHandler;
    if (oldHandler) {
      button.removeEventListener('click', oldHandler);
    }

    const clickHandler = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (button.classList.contains('loading')) {
        return;
      }

      const productId = button.dataset.productid;
      if (!productId) {
        console.error('Product ID not found on button:', button);
        return;
      }

      let formData = {
        items: [
          {
            id: productId,
            quantity: 1
          }
        ]
      };

      button.classList.add('loading');
      button.querySelector('.loading-overlay svg').style.opacity = 1;
      button.querySelector('.single-add-to-cart-button--text').style.display = 'none';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then((response) => {
          button.classList.remove('loading');
          button.querySelector('.loading-overlay svg').style.opacity = 0;
          button.querySelector('.single-add-to-cart-button--text').style.display = 'block';
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: response
            })
          );
          document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

          // Apply discount code if present
          const discountCode = button.dataset.discountCode;
          if (discountCode && discountCode.trim() !== '') {
            fetch(`/discount/${discountCode}`, {
              method: 'GET'
            })
              .then((response) => {
                if (response.ok) {
                  console.log(`Discount code ${discountCode} applied successfully`);
                } else {
                  console.error(`Failed to apply discount code: ${discountCode}`);
                }
              })
              .catch((error) => {
                console.error('Error applying discount code:', error);
              });
          }
        })
        .catch((error) => {
          button.classList.remove('loading');
          button.querySelector('.loading-overlay svg').style.opacity = 0;
          button.querySelector('.single-add-to-cart-button--text').style.display = 'block';
          console.error('Error:', error);
        });
    };

    button._clickHandler = clickHandler;
    button.addEventListener('click', clickHandler);
  });
}

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = Number(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract.addEventListener('click', () => {
        const inCart = this.closest('#Cart-Drawer') || this.closest('#Cart');
        const currentValue = Number(this.input.value);
        if (!inCart) {
          if (currentValue <= 1) return;
          this.change_quantity(-1 * this.step);
        } else {
          if (currentValue <= 0) return;
          if (currentValue === 1) {
            this.input.value = 0;
            this.input.dispatchEvent(this.changeEvent);
            this.validateQtyRules();
          } else {
            this.change_quantity(-1 * this.step);
          }
        }
      });

      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

      this.validateQtyRules();
    }

    connectedCallback() {
      this.classList.add('buttons_added');
    }

    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;

      if (this.input.getAttribute('max')) {
        if (Number(this.input.getAttribute('max')) < quantity + change) {
          return;
        }
      }

      // Change quantity
      quantity += change;
      const inCart = this.closest('#Cart-Drawer') || this.closest('#Cart');
      if (!inCart) {
        quantity = Math.max(quantity, 1);
      } else {
        quantity = Math.max(quantity, 0);
      }

      // Output number
      this.input.value = quantity;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value);
      const parentCartDrawer = this.closest('#Cart-Drawer');
      const parentCart = this.closest('#Cart');

      if (!parentCartDrawer && !parentCart && this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');
    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}

let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }

    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }

    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }
      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });
    }

    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', function () {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }

    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append(
        'sections',
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });

      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }

  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }

    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }

    setEventListeners() {
      if (this.button) {
        this.button.addEventListener('click', this.addToCart.bind(this));
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);
      formData.append(
        'sections',
        this.getSectionsToRender().map((section) => section.section)
      );
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
          dispatchCustomEvent('cart:refresh');
        });
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      });
      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }

  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {
  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            if (document.body.classList.contains('open-cc--product')) {
              document.body.classList.remove('open-cc--product');

              setTimeout(() => {
                document.querySelector('#Product-Drawer-Content').innerHTML = '';
              }, 260);
            } else {
              if (panel.classList.contains('cart-drawer')) {
                document.getElementById('cart-drawer-toggle').focus();
              }
              document.body.classList.remove('open-cc');
            }
            panel.classList.remove('active');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      let panel = document.querySelector('.side-panel.active');
      if (panel) {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    if (document.body.classList.contains('open-cc--product')) {
      document.body.classList.remove('open-cc--product');
      setTimeout(() => {
        document.querySelector('#Product-Drawer-Content').innerHTML = '';
      }, 260);
    } else {
      document.body.classList.remove('open-cc');
    }
  }
}

customElements.define('side-panel-close', PanelClose);

/**
 * Global function to check if any products in cart match with Shopify Metaobject discount_checkout_check
 * @returns {Promise<boolean|string>} - Returns true if match found, 'discount-no-product' if discount code matches but no product matches, false otherwise
 */
window.checkDiscountMetaobject = async function () {
  const metaobjectsQuery = `
    query GetDiscountChecks {
      metaobjects(first: 50, type: "discount_checkout_check") {
        nodes {
          id
          handle
          fields { key value }
        }
      }
    }
  `;

  const metaobjectsRes = await fetch('/api/2025-07/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': theme.storefrontAccessToken
    },
    body: JSON.stringify({ query: metaobjectsQuery })
  });

  const { data: metaobjectsData } = await metaobjectsRes.json();

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const cartQuery = `{
         cart(id: "gid://shopify/Cart/${cart.token}") {
            discountCodes {
               code
            }
            lines(first: 50) {
               edges {
                  node {
                     merchandise {
                        ... on ProductVariant {
                           id
                           product {
                              id
                           }
                        }
                     }
                  }
               }
            }
         }
      }`;

    const cartDiscountResponse = await fetch('/api/2025-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': theme.storefrontAccessToken
      },
      body: JSON.stringify({ query: cartQuery })
    });

    const { data: cartData } = await cartDiscountResponse.json();

    if (
      cartData &&
      cartData.cart &&
      cartData.cart.discountCodes &&
      cartData.cart.discountCodes.length > 0
    ) {
      const productIdsInCart = cartData.cart.lines.edges.map(
        (edge) => edge.node.merchandise.product.id
      );
      const variantIdsInCart = cartData.cart.lines.edges.map((edge) => edge.node.merchandise.id);

      let matchFound = false;
      let discountCodeMatchButNoProduct = false;

      for (const metaobject of metaobjectsData.metaobjects.nodes) {
        let discountCodes = [];
        let productIds = [];
        let variantIds = [];

        for (const field of metaobject.fields) {
          if (field.key === 'discount_code') {
            try {
              const value = field.value.replace(/'/g, '"');
              discountCodes = JSON.parse(value);
            } catch (e) {
              console.error('Error parsing discount_code field:', e);
              const match = field.value.match(/\[['"](.+?)['"]]/);
              if (match && match[1]) {
                discountCodes = [match[1]];
              }
            }
          }

          if (field.key === 'bind_discount_code_to_products') {
            try {
              const value = field.value.replace(/'/g, '"');
              productIds = JSON.parse(value);
            } catch (e) {
              console.error('Error parsing bind_discount_code_to_products field:', e);
              const match = field.value.match(/\[["'](.+?)["']]/);
              if (match && match[1]) {
                productIds = [match[1]];
              }
            }
          }

          if (field.key === 'bind_discount_code_to_product_variants') {
            try {
              const value = field.value.replace(/'/g, '"');
              variantIds = JSON.parse(value);
            } catch (e) {
              console.error('Error parsing bind_discount_code_to_product_variants field:', e);
              const match = field.value.match(/\[["'](.+?)["']]/);
              if (match && match[1]) {
                variantIds = [match[1]];
              }
            }
          }
        }

        const matchingDiscountCodes = cartData.cart.discountCodes.filter((cartCode) =>
          discountCodes.some((metaCode) => metaCode.toUpperCase() === cartCode.code.toUpperCase())
        );

        if (matchingDiscountCodes.length > 0) {
          const matchingProducts = productIdsInCart.filter((cartProductId) =>
            productIds.some((metaProductId) => metaProductId === cartProductId)
          );

          const matchingVariants = variantIdsInCart.filter((cartVariantId) =>
            variantIds.some((metaVariantId) => metaVariantId === cartVariantId)
          );

          if (matchingProducts.length > 0 || matchingVariants.length > 0) {
            matchFound = true;
            break;
          } else {
            discountCodeMatchButNoProduct = true;
          }
        }
      }

      if (matchFound) {
        return true;
      } else if (discountCodeMatchButNoProduct) {
        return 'discount-no-product';
      }
    }
  } catch (error) {
    console.error('Error checking discount codes:', error);
  }

  return false;
};

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    if (window.cartDrawerInstance) return window.cartDrawerInstance;
    window.cartDrawerInstance = this;

    this.container = document.getElementById('Cart-Drawer');
    if (!this.container) return;

    let button = document.getElementById('cart-drawer-toggle');
    if (!button) return;

    button.addEventListener('click', (e) => {
      if (button.href.includes('/checkout')) {
        return;
      }
      e.preventDefault();
      this.openDrawer();
    });

    document.addEventListener('cart:open', () => {
      // Prüfe direkt das data-attribute statt ein Flag zu verwenden
      const productDetail = document.querySelector('.thb-product-detail.product');
      const sampleBox = document.querySelector('.section-qlf-samplebox .multicolumn');
      const activeBlock = document.querySelector(
        '.section-qlf-samplebox .multicolumn__column[data-redirect-active="true"]'
      );
      const shouldRedirect =
        productDetail?.dataset.redirectCheckout === 'true' ||
        sampleBox?.dataset.redirectCheckout === 'true' ||
        activeBlock !== null;

      if (shouldRedirect || window.bundleRedirectActive) {
        window.location.href = '/checkout';
        return;
      }

      if (document.body.classList.contains('open-cc')) {
        this.container.focus();
      } else {
        this.openDrawer();
      }
    });

    document.addEventListener('click', (e) => {
      const isNormalAtc = e.target.closest('.single-add-to-cart-button');
      const isQlfAtc = e.target.closest('.qlf-add-to-cart button');

      if (isNormalAtc || isQlfAtc) {
        const productDetail = document.querySelector('.thb-product-detail.product');
        const sampleBox = document.querySelector('.section-qlf-samplebox .multicolumn');
        const clickedBlock = e.target.closest('.multicolumn__column');

        if (clickedBlock && clickedBlock.dataset.redirectCheckout === 'true') {
          clickedBlock.setAttribute('data-redirect-active', 'true');
          setTimeout(() => {
            clickedBlock.removeAttribute('data-redirect-active');
          }, 5000);
        }

        if (
          (productDetail && productDetail.dataset.redirectCheckout === 'true') ||
          (sampleBox && sampleBox.dataset.redirectCheckout === 'true')
        ) {
          window.bundleRedirectActive = true;
          setTimeout(() => {
            window.bundleRedirectActive = false;
          }, 5000);
        }
      }
    });

    this.debouncedOnChange = debounce((event) => this.onChange(event), 300);
    this.container.addEventListener('change', (event) => {
      if (event.target.classList.contains('qty')) {
        this.debouncedOnChange(event);
      }
    });

    this.debouncedRefresh = debounce(() => this.refresh(), 500);
    document.addEventListener('cart:refresh', () => this.debouncedRefresh());

    this.notesToggle();
    // this.removeProductEvent();
    this.termsCheckbox();
  }

  debouncedCheckDiscount = debounce(() => this.checkDiscountMetaobject(), 500);

  openDrawer() {
    document.body.classList.add('open-cc');
    this.container.classList.add('active');
    this.container.focus();
    dispatchCustomEvent('cart-drawer:open');

    // this.debouncedCheckDiscount();
  }

  async checkDiscountMetaobject() {
    const matchFound = await window.checkDiscountMetaobject();

    if (matchFound === 'discount-no-product') {
      console.log(
        'Removing discount: Found matching discount code but no associated product in cart.'
      );

      fetch('/discount/0', {
        method: 'GET'
      })
        .then((response) => {
          console.log('All discount codes removed from cart');
        })
        .catch((error) => {
          console.error('Error removing discount codes:', error);
        });
    }
  }

  onChange(event) {
    if (event.target.classList.contains('qty') && event.target.dataset.key) {
      this.updateQuantity(event.target.dataset.key, event.target.value);
    }
  }

  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.key, '0');

        event.preventDefault();
      });
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }

  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling
      .querySelectorAll('.button, .order-note-toggle__content-overlay')
      .forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
  }

  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`
      },
      body: JSON.stringify({
        note: document.getElementById('mini-cart__notes').value
      })
    });
  }

  updateQuantity(id, quantity) {
    const cartItem =
      document.getElementById(`CartItem-${id}`) || document.getElementById(`CartDrawerItem-${id}`);

    if (cartItem) {
      const isGiftItem = cartItem.querySelector('.gift-item-qty');
      if (isGiftItem) {
        console.warn('Gift items cannot be modified');
        this.refresh();
        return;
      }
    }

    const drawerItem = document.getElementById(`CartDrawerItem-${id}`);
    if (drawerItem) {
      drawerItem.classList.add('thb-loading');
    }

    const body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });

    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (sectionElement) {
            const elementToReplace =
              sectionElement.querySelector(section.selector) || sectionElement;

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        initializeAddToCartButtons();
        // this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        const finalDrawerItem = document.getElementById(`CartDrawerItem-${id}`);
        if (finalDrawerItem) {
          finalDrawerItem.classList.remove('thb-loading');
        }
        setTimeout(() => this.checkDiscountMetaobject(), 300);
      });
  }

  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (!sectionElement) return;
          const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState[section.section],
            section.selector
          );
        });

        // this.removeProductEvent();
        initializeAddToCartButtons();

        this.notesToggle();
        this.termsCheckbox();
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage(
        '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
        '*'
      );
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}

customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}

customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list')
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel
        .querySelectorAll('button')
        .forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent =
        event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute(
          'aria-expanded',
          (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose =
        event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll(
        'input[name="locale_code"], input[name="country_code"]'
      );
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach((item) =>
        item.addEventListener('change', this.debouncedOnSubmit.bind(this))
      );
    }

    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }

    connectedCallback() {
      this.setupButtonObservers();
    }

    disconnectedCallback() {}

    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }

    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }

    connectedCallback() {
      if (!this.details || !this.summary || !this.content) {
        return;
      }

      this.setListeners();

      if (this.dataset.openDesktop === 'true' && window.innerWidth >= 768) {
        this.details.open = true;
      }

      // Initialize the height for animation
      this.details.style.height = '';
      this.details.style.overflow = '';
    }

    setListeners() {
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      if (this.isExpanding || this.isClosing) {
        e.preventDefault();
        return;
      }

      const willOpen = !this.details.open;

      if (willOpen) {
        e.preventDefault();
        this.closeAll();
        this.open();
      } else {
        e.preventDefault();
        this.shrink();
      }
    }

    closeAll() {
      if (this.dataset.allowMultipleOpen === 'true' || !this.classList.contains('accordion')) {
        return;
      }

      const siblingRows = Array.from(this.parentElement?.children || []).filter((element) =>
        element.matches('collapsible-row.accordion')
      );

      siblingRows.forEach((row) => {
        if (
          row === this ||
          row.dataset.allowMultipleOpen === 'true' ||
          !row.details ||
          (!row.details.open && !row.isExpanding)
        ) {
          return;
        }

        row.shrink();
      });
    }

    shrink() {
      if (this.isClosing || !this.details.open) {
        return;
      }
      // Set the element as "being closed"
      this.isClosing = true;
      this.details.style.overflow = 'hidden';

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        },
        {
          duration: 350,
          easing: 'ease'
        }
      );

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      if (this.isExpanding || this.details.open) {
        return;
      }
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate(
        {
          // Set the keyframes from the startHeight to endHeight
          height: [startHeight, endHeight]
        },
        {
          duration: 400,
          easing: 'ease-out'
        }
      );
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';

      // If a sibling was closed before this opened, the layout shift may have
      // pushed the summary above the viewport – scroll it back into view.
      if (open) {
        const summaryRect = this.summary.getBoundingClientRect();
        if (summaryRect.top < 0) {
          this.summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  }

  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  getDiscount() {
    if (window.updateDatoraDiscounts) {
      window.updateDatoraDiscounts();
    }
  }

  fetchProducts() {
    if (this.loadingProducts) return;

    if (this.dataset.url && !this.classList.contains('product-recommendations--loaded')) {
      if (
        this.innerHTML.trim().length > 0 &&
        this.querySelector('.product-card-small, .product-card, .columns')
      ) {
        this.classList.add('product-recommendations--loaded');
        this.getDiscount();
        return;
      }
      this.loadingProducts = true;
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(`Product recommendations: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            const hasVisibleProducts = recommendations.querySelector(
              '.product-card-small, .product-card, .columns, product-card-small'
            );

            if (hasVisibleProducts) {
              this.innerHTML = recommendations.innerHTML;
              this.classList.add('product-recommendations--loaded');
            }
          }

          initializeAddToCartButtons();

          document.querySelectorAll('.qlf-add-to-cart:not(.bound)').forEach((element) => {
            element.classList.add('bound');
            const button = element.querySelector('button');

            if (!button) {
              return;
            }

            button.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              let formData = {
                items: [
                  {
                    id: button.dataset.productid,
                    quantity: 1
                  }
                ]
              };

              element.querySelector('.loading-overlay svg').style.opacity = 1;
              element.querySelector('.single-add-to-cart-button--text').style.display = 'none';

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
                .then((response) => {
                  element.querySelector('.loading-overlay svg').style.opacity = 0;
                  element.querySelector('.single-add-to-cart-button--text').style.display = 'block';
                  document.dispatchEvent(
                    new CustomEvent('cart:refresh', { bubbles: true, detail: response })
                  );
                  document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
                })
                .catch((error) => {
                  element.querySelector('.loading-overlay svg').style.opacity = 0;
                  element.querySelector('.single-add-to-cart-button--text').style.display = 'block';
                  console.error('Error:', error);
                });
            });
          });

          // ✨ NOW THIS ACTUALLY DOES SOMETHING!
          this.getDiscount();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loadingProducts = false;
        });
    }
  }

  connectedCallback() {
    if (this.hasAttribute('data-load-on-cart-open')) {
      this.onCartOpen = () => this.fetchProducts();
      document.addEventListener('cart-drawer:open', this.onCartOpen);

      // Cart updates replace this element while the drawer is already open.
      if (!document.body.classList.contains('open-cc')) return;
    }

    this.fetchProducts();
  }

  disconnectedCallback() {
    if (this.onCartOpen) {
      document.removeEventListener('cart-drawer:open', this.onCartOpen);
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  const QUICK_VIEW_SCROLL_LOCK_KEY = 'quick-view-product-drawer';
  const QUICK_VIEW_CLOSE_DELAY = 260;

  const getThemeScrollLock = () => {
    if (window.theme && window.theme.scrollLock) {
      return window.theme.scrollLock;
    }

    return {
      lock() {},
      unlock() {}
    };
  };

  const clearQuickViewDrawerContent = (drawer) => {
    setTimeout(() => {
      const drawerContent = drawer?.querySelector('#Product-Drawer-Content');

      if (drawerContent) {
        drawerContent.innerHTML = '';
      }
    }, QUICK_VIEW_CLOSE_DELAY);
  };

  const closeQuickViewDrawer = () => {
    const drawer = document.getElementById('Product-Drawer');

    if (!drawer) {
      return;
    }

    document.body.classList.remove('open-cc--product');
    drawer.classList.remove('active');
    getThemeScrollLock().unlock(QUICK_VIEW_SCROLL_LOCK_KEY);
    clearQuickViewDrawerContent(drawer);
  };

  const initializeQuickViewGlobals = () => {
    if (window.__quickViewGlobalsInitialized) {
      return;
    }

    window.__quickViewGlobalsInitialized = true;

    const clickCapture = document.querySelector('.click-capture--product');
    clickCapture?.addEventListener('click', closeQuickViewDrawer);

    const observer = new MutationObserver(() => {
      if (!document.body.classList.contains('open-cc--product')) {
        getThemeScrollLock().unlock(QUICK_VIEW_SCROLL_LOCK_KEY);
      }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  class QuickView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      if (!this.quickViewListenerBound) {
        this.quickViewListenerBound = true;
        this.addEventListener('click', this.setupEventListener.bind(this));
      }

      initializeQuickViewGlobals();
    }

    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      this.querySelector('.single-add-to-cart-button--text').style.display = 'none';
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          this.querySelector('.single-add-to-cart-button--text').style.display = 'block';
          return response.text();
        })
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const drawerContent = parsed.querySelector('#Product-Drawer-Content');
          if (!drawerContent) return;

          this.renderQuickview(drawerContent.innerHTML, href, productHandle);
        });
    }

    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {
        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer
          .querySelector('#Product-Drawer-Content')
          .querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file) => {
            const type = (js_file.getAttribute('type') || '').trim().toLowerCase();
            if (type && !['text/javascript', 'application/javascript', 'module'].includes(type)) {
              return;
            }
            let script = document.createElement('script');
            if (type) script.type = type;
            if (js_file.src) {
              script.src = js_file.src;
              head.appendChild(script);
            } else if (js_file.textContent.trim()) {
              script.textContent = js_file.textContent;
              head.appendChild(script);
            }
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc--product');
        this.drawer.classList.add('active');
        getThemeScrollLock().lock(QUICK_VIEW_SCROLL_LOCK_KEY, { mobileOnly: true });

        this.drawer.querySelector('.side-panel-close').focus();
        if (this.drawer.querySelector('#Product-Slider')) {
          setTimeout(() => {
            let slider = this.drawer.querySelector('#Product-Slider');

            slider.reInit();
            window.dispatchEvent(new Event('resize'));
          }, 100);
        }
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }

  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {
  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled =
      document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: '0%',
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }
}

let hasInitializedLegacyJQueryUi = false;

function initializeLegacyJQueryUi(retryCount = 0) {
  if (hasInitializedLegacyJQueryUi) {
    return true;
  }

  // app.js runs as an ES module, so legacy jQuery code must resolve from window.
  const $ = window.jQuery || window.$;
  if (!$) {
    if (retryCount < 20) {
      window.setTimeout(() => initializeLegacyJQueryUi(retryCount + 1), 100);
    }
    return false;
  }

  hasInitializedLegacyJQueryUi = true;

  $("a[href='#mehr-erfahren']:not(.bound)")
    .addClass('bound')
    .click(function (e) {
      e.preventDefault();

      $('html').animate(
        {
          scrollTop: $('#mehr-erfahren').offset().top
        },
        400 //speed
      );
    });

  $('.click-capture').appendTo('#wrapper');
  $('.click-capture--product').appendTo('#wrapper');

  function changeColor(el, clr) {
    let elem = document.querySelector(el);
    elem.style.transition = 'color 0.35s linear 0s';
    elem.style.color = clr;
  }

  $('#show-more-garantie').click(function () {
    if ($('.product-information__benefits__inner:nth-of-type(1)').hasClass('open')) {
      $('.product-information__benefits__inner:nth-of-type(1)')
        .removeClass('open')
        .animate({ width: '49%' }, 500);
      $('.product-information__benefits__inner:nth-of-type(2)').animate({ width: '49%' }, 500);
      changeColor('.product-information__benefits__inner:nth-of-type(2) .benefit_text', '#575757');
      $('.product-information__benefits__inner:nth-of-type(2) img').animate({ opacity: '1' }, 300);
      $('.product-information__benefits__inner:nth-of-type(2) .show-more').animate(
        { opacity: '1' },
        300
      );
      $('.product-information__benefits__inner:nth-of-type(1) .read-more').fadeOut(
        200,
        function () {
          $('.product-information__benefits__inner:nth-of-type(1) .benefit_text').fadeIn(200);
        }
      );
    } else {
      if ($(window).width() < 768) {
        $('.product-information__benefits__inner:nth-of-type(1) .read-more').css(
          'width',
          $(window).width() - 40 + 'px'
        );
      }
      $('.product-information__benefits__inner:nth-of-type(1)')
        .addClass('open')
        .animate({ width: '100%' }, 500);
      $('.product-information__benefits__inner:nth-of-type(2)').animate({ width: '0%' }, 500);
      changeColor(
        '.product-information__benefits__inner:nth-of-type(2) .benefit_text',
        'transparent'
      );
      $('.product-information__benefits__inner:nth-of-type(2) img').animate({ opacity: '0' }, 300);
      $('.product-information__benefits__inner:nth-of-type(2) .show-more').animate(
        { opacity: '0' },
        300
      );
      $('.product-information__benefits__inner:nth-of-type(1) .benefit_text').fadeOut(
        200,
        function () {
          $('.product-information__benefits__inner:nth-of-type(1) .read-more').fadeIn(200);
        }
      );
    }
  });

  $('#show-more-kaeuferschutz').click(function () {
    if ($('.product-information__benefits__inner:nth-of-type(2)').hasClass('open')) {
      $('.product-information__benefits__inner:nth-of-type(2)')
        .removeClass('open')
        .animate({ width: '49%' }, 500);
      $('.product-information__benefits__inner:nth-of-type(1)').animate({ width: '49%' }, 500);
      changeColor('.product-information__benefits__inner:nth-of-type(1) .benefit_text', '#575757');
      $('.product-information__benefits__inner:nth-of-type(1) img').animate({ opacity: '1' }, 300);
      $('.product-information__benefits__inner:nth-of-type(1) .show-more').animate(
        { opacity: '1' },
        300
      );
      $('.product-information__benefits__inner:nth-of-type(2) .read-more').fadeOut(
        200,
        function () {
          $('.product-information__benefits__inner:nth-of-type(2) .benefit_text').fadeIn(200);
        }
      );
    } else {
      if ($(window).width() < 768) {
        $('.product-information__benefits__inner:nth-of-type(2) .read-more').css(
          'width',
          $(window).width() - 40 + 'px'
        );
      }
      $('.product-information__benefits__inner:nth-of-type(2)')
        .addClass('open')
        .animate({ width: '100%' }, 500);
      $('.product-information__benefits__inner:nth-of-type(1)').animate({ width: '0%' }, 500);
      changeColor(
        '.product-information__benefits__inner:nth-of-type(1) .benefit_text',
        'transparent'
      );
      $('.product-information__benefits__inner:nth-of-type(1) img').animate({ opacity: '0' }, 300);
      $('.product-information__benefits__inner:nth-of-type(1) .show-more').animate(
        { opacity: '0' },
        300
      );
      $('.product-information__benefits__inner:nth-of-type(2) .benefit_text').fadeOut(
        200,
        function () {
          $('.product-information__benefits__inner:nth-of-type(2) .read-more').fadeIn(200);
        }
      );
    }
  });

  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  initializeAddToCartButtons();
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const productCountElements = document.querySelectorAll('.qlf-ts-rating__count_number');

  productCountElements.forEach(function (element) {
    const count = element.textContent.trim();
    element.textContent = numberWithCommas(count);
  });

  initializeLegacyJQueryUi();
});

document.addEventListener('DOMContentLoaded', function () {
  var isTouchDevice = 'ontouchstart' in document.documentElement;
  if (isTouchDevice) {
    var menuLinks = document.querySelectorAll('.menu-link');
    menuLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var dropdown = this.nextElementSibling;

        var openDropdowns = document.querySelectorAll('.main-navigation__category.open');
        openDropdowns.forEach(function (openDropdown) {
          if (openDropdown !== dropdown) {
            openDropdown.classList.remove('open');
          }
        });

        if (dropdown && !dropdown.classList.contains('open')) {
          event.preventDefault();
          dropdown.classList.add('open');
        }
      });
    });
  }

  const screenPadding = 16;
  const sourceLinks = document.querySelectorAll('a[href*="#referenz-"]');

  sourceLinks.forEach((link) => {
    const sourceId = link.getAttribute('href').split('#referenz-')[1];
    const sourceTextElement = document.getElementById(`referenz-${sourceId}`);

    link.innerHTML = link.innerHTML.replace(/<br\s*\/?>/gi, ' ');

    if (sourceTextElement) {
      const sourceText = sourceTextElement.textContent;
      if (!link.querySelector('.source-text')) {
        const tooltip = document.createElement('div');
        tooltip.className = 'source-text';
        tooltip.textContent = sourceText;
        tooltip.style.position = 'absolute';
        tooltip.style.display = 'none';
        tooltip.style.backgroundColor = '#fff';
        tooltip.style.border = '1px solid #ccc';
        tooltip.style.padding = '5px';
        tooltip.style.zIndex = '1000';
        tooltip.style.whiteSpace = 'normal';
        link.appendChild(tooltip);
      }
    }
    link.addEventListener('mouseover', showTooltip);
    link.addEventListener('mouseout', hideTooltip);
    link.addEventListener('click', (event) => event.preventDefault());
    link.addEventListener('touchstart', showTooltip);
    link.addEventListener('touchend', hideTooltip);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('a[href*="#referenz-"]') && !event.target.closest('.element')) {
      const tooltips = document.querySelectorAll('.source-text');
      tooltips.forEach((tooltip) => {
        tooltip.style.display = 'none';
      });
    }
  });

  document.querySelectorAll('.element:not(.bound)').forEach((element) => {
    element.classList.add('bound');
    element.addEventListener('click', function () {
      const tooltip = this.querySelector('.source-text');
      if (tooltip) {
        tooltip.style.display =
          tooltip.style.display === 'none' || tooltip.style.display === '' ? 'block' : 'none';
      }
    });
  });

  function showTooltip(event) {
    const link = event.currentTarget;
    const tooltip = link.querySelector('.source-text');
    if (tooltip) {
      tooltip.style.display = 'block';
      adjustTooltipPosition(link, tooltip);
    }
  }

  function hideTooltip(event) {
    const link = event.currentTarget;
    const tooltip = link.querySelector('.source-text');
    if (tooltip) {
      tooltip.style.display = 'none';
    }
  }

  function adjustTooltipPosition(link, tooltip) {
    const linkRect = link.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    tooltip.style.left = '100%';
    tooltip.style.right = 'auto';
    tooltip.style.top = '0';
    tooltip.style.marginLeft = '10px';
    tooltip.style.transform = 'translateX(0)';

    if (linkRect.right + tooltipRect.width + screenPadding > viewportWidth) {
      tooltip.style.left = 'auto';
      tooltip.style.right = '100%';
      tooltip.style.marginRight = '10px';
    }

    if (linkRect.left - tooltipRect.width < screenPadding) {
      tooltip.style.left = '0';
      tooltip.style.right = 'auto';
      tooltip.style.transform = `translateX(${screenPadding - linkRect.left}px)`;
    }

    const tooltipAdjustedRect = tooltip.getBoundingClientRect();
    if (tooltipAdjustedRect.right > viewportWidth) {
      tooltip.style.left = 'auto';
      tooltip.style.right = '0';
      tooltip.style.transform = `translateX(${viewportWidth - tooltipAdjustedRect.right - screenPadding}px)`;
    }
    if (tooltipAdjustedRect.left < 0) {
      tooltip.style.left = '0';
      tooltip.style.right = 'auto';
      tooltip.style.transform = `translateX(${screenPadding}px)`;
    }

    if (window.innerWidth <= 768) {
      tooltip.style.marginTop = '20px';
    }
  }

  function scrollToElement() {
    const hash = window.location.hash;
    if (!hash || hash === '#') return;

    const rawTargetId = hash.slice(1);
    let targetId = rawTargetId;

    try {
      targetId = decodeURIComponent(rawTargetId);
    } catch (error) {
      targetId = rawTargetId;
    }

    const targetElement =
      document.getElementById(targetId) || document.getElementsByName(targetId)[0];

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      history.replaceState(null, null, window.location.pathname + window.location.search);
    }
  }

  scrollToElement();

  const paginationLinks = document.querySelectorAll('.page-numbers a');
  paginationLinks.forEach((link) => {
    link.addEventListener('click', function (event) {
      const href = this.getAttribute('href');
      if (href) {
        this.setAttribute('href', href + '#comments');
      }
    });
  });

  adjustReadMoreText();
});

function adjustReadMoreText() {
  const buttons = document.querySelectorAll('.read-more-button');

  buttons.forEach(function (button) {
    const container = button.parentNode;
    const text = container.querySelector('.read-more-text');
    const dots = container.querySelector('.dots');

    if (!button.classList.contains('expanded')) {
      text.style.display = 'none';
      dots.style.display = 'inline';
    }

    button.style.display = 'inline-flex';
  });
}

function toggleReadMore(button) {
  const container = button.parentNode;
  const text = container.querySelector('.read-more-text');
  const dots = container.querySelector('.dots');
  const icon = button.querySelector('#read-more-icon');

  if (text.style.display === 'none') {
    text.style.display = 'inline';
    button.querySelector('.button-text').textContent = 'Weniger anzeigen';
    button.classList.add('expanded');
    dots.style.display = 'none';
    icon.classList.add('rotated');
  } else {
    text.style.display = 'none';
    button.querySelector('.button-text').textContent = 'Mehr anzeigen';
    button.classList.remove('expanded');
    dots.style.display = 'inline';
    icon.classList.remove('rotated');
  }
}

// ---------------------------------------------------------------------------
// Vorbestellungs-Produktkarten (Tag `preorder`) → Produktseite statt Quick-View.
// Karten mit dem Tag `preorder` tragen data-preorder="true" + data-product-url
// (siehe product-card.liquid / qlf-product-variant-card.liquid).
// Fängt sowohl das Theme-<quick-view> als auch den vom A/B-Test (ablyft)
// injizierten Button `.as-lf-0014-btn` ("Variante auswählen") ab. Capture-Phase +
// stopImmediatePropagation, damit wir vor dem fremden Click-Handler greifen.
// ---------------------------------------------------------------------------
document.addEventListener(
  'click',
  (e) => {
    const trigger = e.target.closest('.as-lf-0014-btn, quick-view');
    if (!trigger) return;
    const card = trigger.closest('[data-preorder="true"]');
    if (!card) return;
    const url =
      card.getAttribute('data-product-url') ||
      (card.querySelector('a.product-featured-image-link, a.product-card-title') || {}).href;
    if (!url) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url;
  },
  true
);
